import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import {
  useNavigate,
  useSearchParams,
  useParams,
  Link as RouterLink,
} from "react-router-dom";
import { getLandDetailsById } from "src/utils/api/createProjectFlow";
import ProjectOverview from "src/components/common/ProjectOverview";
import SiteVisitDetails from "src/components/common/FormComponents/SiteVisitDetails/siteVisitDetails";
import { getProjectById } from "src/utils/api/dashboard";
import QueryDetails from "src/components/common/QueryDetails";
import ProjectDetailSkeleton from "src/components/common/ProjectDetailSkeleton";

const ViewDetails = (): JSX.Element => {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const params = useParams();
  const [projectData, setProjectData] = useState<any>(null);
  const [projectDataByEpid, setProjectDataByEpid] = useState<any>(null);
  const [siteVisitData, setSiteVisitData] = useState<any>(null);
  const [queryData, setQueryData] = useState<any>(null);

  const epid = search.get("id") || params.id;

  useEffect(() => {
    if (epid) {
      fetchProjectOptionsDetails();
    }
  }, [epid]);

  async function fetchProjectOptionsDetails() {
    try {
      // First resolve land-ownership details (EPID) to get the internal project id
      const landRes = await getLandDetailsById(epid as string);
      //   const resolvedProject = landRes?.data;
      setProjectDataByEpid(landRes?.data);
      setSiteVisitData({
        status: landRes?.data?.status,
        siteVisitFirstDate: landRes?.data?.siteVisitFirstDate,
        siteVisitConfirmation: landRes?.data?.siteVisitConfirmation,
        siteVisitConfirmationRemarks:
          landRes?.data?.siteVisitConfirmationRemarks,
        siteVisitedByEntity: landRes?.data?.siteVisitedByEntity,
        siteDeselect: landRes?.data?.siteDeselect,
        siteDeselectReason: landRes?.data?.siteDeselectReason,
      });

      const details = await getProjectById(landRes?.data?.projectDetail?.id);

      // setProjectData({
      //   ...landRes?.data,
      //   landSpecificationOld: details?.data?.landSpecification,
      // });
      setProjectData(details?.data);
      setQueryData(details?.data?.projectQuery);
    } catch (error) {
      console.error("Error fetching project options details:", error);
    }
  }

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
      {projectData && projectData?.length !== 0 ? (
        <>
          <ProjectOverview
            projectData={projectData}
            siteVisitData={siteVisitData}
            projectDataByEpid={projectDataByEpid}
          />
          {/* <SiteVisitDetails {...siteVisitData} /> */}
          {/* <QueryDetails queries={queryData} /> */}
        </>
      ) : (
        <ProjectDetailSkeleton sections={[5, 3]} />
      )}
    </Box>
  );
};

export default ViewDetails;
